define('checkPreInit/onInit',['lodash', './errorActions'], function(_, errorActions) {
	'use strict';
    return {
        onInit: onInit
    };

    function onInit(data, callback) {
        return function(errorObj) {
            var match,errorString;
            if (errorObj) {
                if(errorObj.errorAction){
                    errorString = errorObj.errorAction;    
                } else {
                    errorString = errorObj;
                }
                data.error = errorObj.errorAction;
                data.errorData = errorObj.errorDescObj;
                match = _.find(errorActions, function(mapObj) {
                    return mapObj.errors.indexOf(errorString) >= 0;
                });
            }
            if (match && match.action) {
                _.defer(match.action, data);
            } else if (match && match.fragment) {
                data.fragment = match.fragment;
                _.defer(callback, data);
            } else {
                _.defer(callback, data);
            }
        };
    }
});
